import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent } from "vue"
import _imports_0 from '@/assets/menu_icons/Utilizatori.png'


const _hoisted_1 = { style: {"padding-left":"3vw","padding-right":"3vw","padding-top":"2vw","min-height":"calc(100vh - 52px)"} }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = {
  key: 0,
  class: "app__page__title__container",
  style: {"display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_4 = {
  class: "app__page__title",
  style: {"white-space":"nowrap"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"position":"relative","zoom":"0.8","width":"28px","height":"24px"}
}, null, -1)
const _hoisted_6 = { style: {"display":"flex","flex-direction":"row","margin-left":"auto"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  style: {"max-width":"15px","height":"auto"},
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABApJREFUaEPtV3tMjWEY/52SCrmvi2uhRihMLjVJ/pCae0tktdJFSYdCO25rTTYsOkdHjnKpRM3cynWoqdzmMrcwK9mYZDFy6d6x92w1q/dzvu97szPzPf8+l9/ze37v973PKzNb76bFP2wyiYCB1ZMUMLAAkBSQFGCcgHSEGAfInP5/KdDX3AJ5QTtgYdqDOrnm1hYszdyEqtoaqj/WIwC+zp6cU79R8RCK82pBqghWYImzJ46tSOQEOfOkCMuzt3byOw92QMmagzAx7kbNrf72GdNSgvGh9tPfJUCqa/wUCHTx4QTyO6pAQVlJu9+0mwlKYzIwzmYkp3JeB2Jws/KxoOZJsGAFSFLP7mYolWdgtKUtFZAcoYm7V+Br/Xedf7t3JOJmBXA2F1+QClVxruDmRRMgiWOtR6AkJh3mJqZUYHXpSaw/p8SU4WNRGJUGYyMjatz5slL4ZSqg1Yrb6kUp0NbJKtfF2LsoltpYq7YV3pq1Ov8YK7pSFTXv4KYMbVdKjARMBAhgbmASFoyfScVuaG4COf80+9lUD499EXhaVSGm7/YcZgJ9zHvh7rojGN7PRlAj4Xk7kH3/oqAcWjAzAVJ08lBHFK7ez/mL7Ah86E4+ok/tYm6e6SPuiB4/OwgJXmF6m3ryvhweqRGoa2rQG8snoEsUIEBGMiPkhyZjtoMLJ+6Xum9wVa5E5af3fHrjFdNlBAgaWRWSfCI5gcmqMFcjF/3L/GvfACk8zXY8rqxSobsx/a/TBr7tkga7C7N5TZdPUJcoYN17AG7JD8Gm90C9mOR+mJ8Rh+uv7umN5RPATIAsZ5cjVHC1c+KDp4v5qFvcQji3Vt6FxO5CvwOofTciZOp8IZi62JLXj+CtkYOs4CzGpABpnBCgGdltNuSrkOAVjl6m5tSY5KIcbLmYxtK/uG2UILoMc8TVSDXnqpBy44TucRLk4oMDfgpOkv5Zm5H/rFg0CVEKWFr0xy15Bgb3saQCP3j7Ap7qKDS2NOn85AFEHkI0+1L3Ha7KENF3g2AC5KO9EJ6CGSMmcDY0PSUYbz5XtfvJU/RebCaG9KUTZrmdBRPYs3AdIt2WcEoemJOAk4+udfJ72k9GQdge3Y1Ns4O3z0B+OlnwURJEYNmkOTi8rPN7tw017eYpxJ7dy9nEznnRiHH35/SH5m5HzoPLgkjwJuA0yB5F0WnoYWJGBXhWVQH3feF/XNLI26B4TTqcBo2i1vjRWA93VRieV1fyJsGLAFkPsgISMKyfNbVwi7YFwccTUV7zTi+wo5Ud0v03QwYZNfZF9RuE5SWB3Nh8jBcBPoUMFSMRMNTk23AlBSQFGCcgHSHGATKnSwowj5CxgMwszu0lYw2DptMXEoO2JAz8nyfwCxCFd8zbDrrDAAAAAElFTkSuQmCC"
}, null, -1)
const _hoisted_8 = { class: "q-pa-xs col-xs-12 col-sm-6 col-md-4" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { style: {"display":"flex","flex-direction":"column","margin-left":"1rem"} }
const _hoisted_11 = { class: "app__property--medium" }
const _hoisted_12 = { class: "app__property--medium" }
const _hoisted_13 = { style: {"display":"flex","flex-direction":"column","margin-left":"10px"} }
const _hoisted_14 = { style: {"text-align":"right"} }
const _hoisted_15 = { class: "app__label--small" }
const _hoisted_16 = { style: {"text-align":"right"} }
const _hoisted_17 = { class: "app__label--small" }
const _hoisted_18 = { style: {"text-align":"right"} }
const _hoisted_19 = { class: "app__label--small" }
const _hoisted_20 = { style: {"text-align":"right"} }
const _hoisted_21 = { class: "app__label--small" }
const _hoisted_22 = { class: "app__property--medium" }
const _hoisted_23 = {
  key: 0,
  class: "app__title--small",
  style: {"position":"absolute","left":"50%","margin-left":"-100px"}
}
const _hoisted_24 = {
  key: 1,
  class: "app__title--small",
  style: {"position":"absolute","left":"calc(50% - 100px)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.users')) + " " + _toDisplayString(_ctx.company.name), 1)
            ]),
            (_ctx.$q.platform.is.desktop)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  style: {"margin-left":"1rem","width":"24px","height":"24px","background-color":"#9b7d32","color":"white"},
                  color: "#273233",
                  icon: "add",
                  onClick: _ctx.openFormAddNewUser
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('message.add_new_user')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_q_input, {
          label: _ctx.$t('message.user'),
          modelValue: _ctx.filterText,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterText) = $event)),
            _cache[2] || (_cache[2] = ($event: any) => (_ctx.getUsers()))
          ],
          outlined: "",
          dense: ""
        }, {
          append: _withCtx(() => [
            (_ctx.filterText !== '')
              ? (_openBlock(), _createBlock(_component_q_icon, {
                  key: 0,
                  name: "close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.filterText = '';_ctx.getUsers()}),
                  class: "cursor-pointer"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_icon, { name: "search" })
          ]),
          _: 1
        }, 8, ["label", "modelValue"]),
        _createVNode(_component_q_input, {
          outlined: "",
          dense: "",
          modelValue: _ctx.searchAgent,
          "onUpdate:modelValue": [
            _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchAgent) = $event)),
            _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterUsers()))
          ],
          label: _ctx.$t('message.agent2'),
          style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);margin-left: 8px;')
        }, null, 8, ["modelValue", "label", "style"]),
        _createVNode(_component_q_btn, {
          "no-caps": "",
          loading: _ctx.downloadingXLS,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadXLS(_ctx.$t('message.users')))),
          size: "md",
          style: {"margin-left":"8px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.export')) + " XLS", 1),
            _createVNode(_component_q_avatar, { size: "15px" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    (_ctx.$q.platform.is.mobile)
      ? (_openBlock(), _createBlock(_component_q_table, {
          key: 0,
          grid: "",
          "rows-per-page-options": [10],
          rows: _ctx.usersFiltered,
          columns: _ctx.columns,
          "visible-columns": _ctx.visibleColumns,
          "row-key": "appid",
          filter: _ctx.filter,
          loading: _ctx.loadingData,
          pagination: _ctx.myPagination,
          "no-data-label": _ctx.$t('message.no_data')
        }, {
          top: _withCtx(() => [
            _createVNode(_component_q_space),
            _createVNode(_component_q_input, {
              dense: "",
              debounce: "300",
              color: "#273233",
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filter) = $event))
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "search" })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          item: _withCtx((props) => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_q_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { style: {"display":"flex"} }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_q_avatar, { size: "52px" }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: props.row.urlUserImgProfileByAppid
                          }, null, 8, _hoisted_9)
                        ]),
                        _: 2
                      }, 1536), [
                        [_directive_close_popup]
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(props.row.firstName), 1),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(props.row.lastName), 1)
                      ]),
                      _createVNode(_component_q_icon, {
                        name: "manage_accounts",
                        class: "text-blue cursor-pointer",
                        style: {"font-size":"1.5rem","margin-left":"auto"},
                        onClick: ($event: any) => (_ctx.openUserDetails(props.row.appid))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_separator),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("table", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_14, [
                              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('message.user_id')) + ":", 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, _toDisplayString(props.row.userid), 1)
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_16, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('message.company')) + ":", 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, _toDisplayString(props.row.companyName), 1)
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_18, [
                              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('message.phone')) + ":", 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, _toDisplayString(props.row.phoneNr), 1)
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_20, [
                              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('message.email')) + ":", 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, _toDisplayString(props.row.emailAddress), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination", "no-data-label"]))
      : (_openBlock(), _createBlock(_component_q_table, {
          key: 1,
          dense: "",
          flat: "",
          "rows-per-page-options": [10],
          rows: _ctx.usersFiltered,
          columns: _ctx.columns,
          "visible-columns": _ctx.visibleColumns,
          "row-key": "appid",
          filter: _ctx.filter,
          loading: _ctx.loadingData,
          pagination: _ctx.myPagination,
          "no-data-label": _ctx.$t('message.no_data')
        }, {
          body: _withCtx((props) => [
            _createVNode(_component_q_tr, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_q_td, {
                  key: "userid",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "manage_accounts",
                      class: "text-blue cursor-pointer",
                      style: {"font-size":"1.5rem"},
                      onClick: ($event: any) => (_ctx.openUserDetails(props.row.appid))
                    }, null, 8, ["onClick"]),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(props.row.userid), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "firstName",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.firstName), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "lastName",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.lastName), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "phoneNr",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.phoneNr), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "emailAddress",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.emailAddress), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "type",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getType(props.row.tip)), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "isDisabled",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_checkbox, {
                      modelValue: props.row.isDisabled,
                      "onUpdate:modelValue": [($event: any) => ((props.row.isDisabled) = $event), ($event: any) => (_ctx.changeStatus(props.row))],
                      label: _ctx.$q.platform.is.mobile? _ctx.$t('message.visible') :'',
                      "true-value": "y",
                      "false-value": "n"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "companyName",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.companyName), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "id_team",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getTeam(props.row.id_team)), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "agent_name",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.agent_name), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      color: "red",
                      flat: "",
                      onClick: ($event: any) => (_ctx.deleteUser(props.row)),
                      "no-caps": "",
                      "no-wrap": "",
                      dense: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          left: "",
                          name: "delete_forever"
                        }),
                        _createVNode(_component_q_tooltip, {
                          anchor: "top middle",
                          self: "bottom middle",
                          offset: [10, 10],
                          "transition-show": "scale",
                          "transition-hide": "scale"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.delete')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_q_btn, {
                      color: "red",
                      flat: "",
                      onClick: ($event: any) => (_ctx.resetPassword(props.row)),
                      "no-caps": "",
                      "no-wrap": "",
                      dense: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          left: "",
                          name: "lock_reset"
                        }),
                        _createVNode(_component_q_tooltip, {
                          anchor: "top middle",
                          self: "bottom middle",
                          offset: [10, 10],
                          "transition-show": "scale",
                          "transition-hide": "scale"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.reset_password')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 1
        }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination", "no-data-label"])),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogUser,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogUser) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": _ctx.dialogTransitionShow,
      "transition-hide": _ctx.dialogTransitionHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  dense: "",
                  flat: "",
                  color: "black",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "arrow_back_ios",
                      style: {"font-weight":"bold"}
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_directive_close_popup]
                ]),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.titleComponent), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.titleComponent), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createBlock(_component_q_space, {
                      key: 2,
                      dense: ""
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dynamicComponent), {
                  userappid: _ctx.selectedUser.appid,
                  companyAppid: _ctx.companyAppid,
                  fnOnSaveData: _ctx.fnOnSaveData
                }, null, 8, ["userappid", "companyAppid", "fnOnSaveData"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "transition-show", "transition-hide"])
  ]))
}